import { useContext } from "react";
import { globalContext } from "../../global/Store";
import config from "../../config/Config.json";
import { GetMockMilestoneNoteRead } from "../../mock/milestone-note/MilestoneNoteRead";
import { GetMockMilestoneNoteList } from "../../mock/milestone-note/MilestoneNoteList";

export const useMilestoneNoteDataRepo = () => {
  const { globalState, dispatch, globalFunctions } = useContext(globalContext);

  const GetMilestoneNote = (id: number) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockMilestoneNoteRead());
      } else {
        globalFunctions
          .CallPortalApi("MilestoneNote/Read", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  const GetMilestoneNoteList = (id: number, incDeleted: boolean) => {
    return new Promise(function (resolve, reject) {
      if (config.RunMode === "MOCK") {
        resolve(GetMockMilestoneNoteList());
      } else {
        globalFunctions
          .CallPortalApi("MilestoneNote/List", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + globalState.user.token,
            },
            body: JSON.stringify({
              Id: id,
              IncludeDeleted: incDeleted,
            }),
          })
          .then(
            function (response: any) {
              resolve(response);
            },
            function (error: any) {
              reject(error);
            }
          );
      }
    });
  };

  return { GetMilestoneNote, GetMilestoneNoteList };
};
